import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import seven from "../../assets/images/user/7.jpg";
import one from "../../assets/images/user-card/1.jpg";
import three from "../../assets/images/user-card/3.jpg";
import two from "../../assets/images/user-card/2.jpg";
import sixteen from "../../assets/images/avtar/16.jpg";
import eleven from "../../assets/images/avtar/11.jpg";
import four from "../../assets/images/avtar/3.jpg";

import { CountryList } from "../../utlis/constant";
import ProfileUloadModal from "./model";
import { Button, Form } from "reactstrap";
import $ from "jquery";
import { apiURL } from "../../utlis/config";
import "./index.css";
import store from "store";
import { toast } from "react-toastify";
class MemberEdit extends Component {
  constructor(props) {
    super();
    this.addAccessor = this.memberInfoUpdate.bind(this);
  }
  state = {
    password: "",
    confirmPassword: "",
    profileImage: "",
    memberInfo: store.get("staffMember"),
    AESKey: "",
    connection: false,
    checkbox: false,
  };
  memberInfoUpdate = (e) => {
    e.preventDefault();
    console.log("Trigger", e.target);
    const data1 = new FormData(e.target);
    var data = {
      email: data1.get("email"),
      name: data1.get("name"),
      city: data1.get("city"),
      aboutMe: data1.get("aboutMe"),
      postalCode: data1.get("postalCode"),
      company: data1.get("company"),
      country: data1.get("country"),
      address: data1.get("address"),
      contactNumber: data1.get("contactNumber"),
    };
    ProfileUloadModal.memberInfoUpdate(data).then((response) => {
      if (!response.error) {
        this.updateEvent(response.data);
        toast.success(response.memberMessage);
      } else {
        // this.setShow(false)
        toast.error(response.memberMessage);
      }
    });

    console.log(data1.get("name"), "dgajsdf"); // reference by form input's `name` tag
  };

  importImage = (e) => {
    console.log("hiiiii");
    $("#importImage").val("");
    $("#importImage").trigger("click");
  };
  changeFile = (e) => {
    console.log("hello");
    e.preventDefault();
    var profileImage = e.target.files[e.target.files.length - 1];
    // var profileImage = e.target.files[e.target.files.length - 1];
    const fileType = profileImage["type"];
    const validImageTypes = ["image/jpeg", "image/png"];
    if (!validImageTypes.includes(fileType)) {
      alert("Please upload valid image", "red");
      return false;
    }
    this.setState({ profileImage });
    console.log(" ctrl.profileImage--1", profileImage);
    $("#profileImageUpload").val("");
    $("#profileImageUpload").trigger("click");
  };
  insertProfileImage = (e) => {
    const { profileImage } = this.state;
    if (profileImage != "") {
      ProfileUloadModal.memberProfileUpdate(profileImage).then((response) => {
        if (!response.error) {
          this.setState({ profileImage: "" });
          this.updateEvent(response.data);
          toast.success(response.memberMessage);
        } else {
          toast.error(response.memberMessage);
        }
      });
    }
    return false;
  };

  passwordUpdate = () => {
    const { password, confirmPassword } = this.state;
    if (password.trim() != "" && confirmPassword.trim() !== "") {
      if (password.trim().length > 7) {
        if (password === confirmPassword) {
          ProfileUloadModal.memberPasswordUpdate({ password }).then(
            (response) => {
              if (!response.error) {
                this.setState({ password: "", confirmPassword: "" });
                this.updateEvent(response.data);
                toast.success(response.memberMessage);
              } else {
                toast.error(response.memberMessage);
              }
            }
          );
        } else {
          toast.error("Password mismatch.");
        }
      } else {
        toast.error(
          "Short password are easy guess. Try one with at least 8 characters"
        );
      }
    } else {
      if (password == "") {
        toast.error("Please enter password.");
      } else {
        toast.error("Please enter confirm password.");
      }
    }
    return false;
  };
  updateEvent = (memberInfo) => {
    this.setState({ memberInfo });
    store.set("staffMember", memberInfo);
    var event = new CustomEvent("memberInfo", {
      detail: { memberInfo: memberInfo },
    });
    document.dispatchEvent(event);
  };

  render() {
    const { memberInfo, password, confirmPassword } = this.state;
    const setPassword = (password) => {
      //console.log({ email });
      this.setState({ password });
    };
    const setConfirmPassword = (confirmPassword) => {
      //console.log({ password });
      this.setState({ confirmPassword });
    };
    return (
      <Fragment>
        <Breadcrumb parent="Staff" title="Profile" />
        <div className="container-fluid">
          <div className="edit-profile">
            <div className="row">

              <div className="col-md-4 col-lg-4 col-xl-4">
                <div className="card border-0" style={{ borderRadius: "8px", boxShadow: '1px 5px 24px 0 rgba(68,102,242,.05)' }}>
                  <div className="card-header p-0" style={{ overflow: "hidden", border: "none", background: "#fff" }}>
                    <img className="img-fluid" src={one}
                      style={{
                        borderTopRightRadius: "8px",
                        borderTopLeftRadius: "8px",
                        borderBottomLeftRadius: "50%",
                        borderBottomRightRadius: "50%",
                        marginTop: "-40px"
                      }}
                    />
                  </div>

                  {/******** Profile section ******/}
                  <div className="card-profile" style={{ textAlign: "center", height: "120px" }}>
                    <div>
                      <img
                        className="rounded-circle"
                        style={{
                          height: "150px",
                          width: "150px",
                          boxShadow: "0 0 4px 0 rgba(0,0,0,.36)",
                          padding: "7px",
                          background: "#fff",
                          zIndex: 1,
                          position: "relative",
                          top: -50
                        }}
                        src={
                          memberInfo.profilePicUrl
                            ? `${apiURL}${memberInfo.profilePicUrl}`
                            : four
                        }
                        alt=""
                      />
                    </div>
                    <a className="profile-edit-button" style={{ top: -90 }}>
                      <i
                        className="bi bi-camera-fill"
                        style={{ color: "#000" }}
                        onClick={(e) => this.importImage()}
                      ></i>{" "}
                    </a>
                    <input
                      type="file"
                      class="form-control"
                      id="importImage"
                      name="image"
                      onChange={this.changeFile}
                      style={{ display: "none" }}
                    />
                    <button
                      id="profileImageUpload"
                      type="button"
                      style={{ display: "none" }}
                      onClick={this.insertProfileImage()}
                      class="btn btn-info"
                      value="Insert"
                    ></button>
                  </div>

                  <div className="text-center profile-details">
                    <h4
                      style={{
                        fontSize: "24px",
                        color: "#313131"
                      }}>{memberInfo.name}</h4>
                    <h6
                      style={{
                        fontSize: "14px",
                        color: "#777777",
                        marginBottom: "30px"
                      }}
                    >{memberInfo.email}</h6>
                  </div>

                  {/****** Update passowrd form *****/}
                  <div style={{ padding: "30px" }}>
                    <div className="form-group" style={{ marginBottom: "16px" }}>
                      <label className="form-label">New Password</label>
                      <input
                        className="form-control"
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      // value="password"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Confirm Password</label>
                      <input
                        className="form-control"
                        type="password"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      // value="password"
                      />
                    </div>
                  </div>
                  <div className="card-footer" style={{ borderTop: "1px solid #f6f7fb", background: "#fff", padding: "30px" }}>
                    <button
                      className="btn btn-primary m-t-30 float-end"
                      type="button"
                      onClick={() => {
                        this.passwordUpdate();
                      }}
                    >
                      Update Password
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-lg-8" style={{ background: "#fff", boxShadow: '1px 5px 24px 0 rgba(68,102,242,.05' }}>
                <Form
                  className="card border-0"
                  style={{ padding: "30px" }}
                  method="create"
                  onSubmit={this.memberInfoUpdate}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">Company</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Company"
                            defaultValue={memberInfo.dealerId.name || ""}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-3" >
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">Role</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Role"
                            name="role"
                            defaultValue={
                              memberInfo.accessLevel === 1
                                ? "Supper Admin"
                                : "Admin" || ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">Email address</label>
                          <input
                            className="form-control"
                            type="email"
                            placeholder="Email"
                            name="email"
                            defaultValue={memberInfo.email || ""}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">Name</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            name="name"
                            defaultValue={memberInfo.name || ""}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">Contact Number</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Contact Number"
                            name="contactNumber"
                            defaultValue={memberInfo.contactNumber || ""}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">Address</label>
                          <input
                            className="form-control"
                            type="text"
                            name="address"
                            placeholder="Home Address"
                            defaultValue={memberInfo.address || ""}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">City</label>
                          <input
                            className="form-control"
                            type="text"
                            name="city"
                            placeholder="City"
                            defaultValue={memberInfo.city || ""}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-3">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">Postal Code</label>
                          <input
                            className="form-control"
                            type="number"
                            name="postalCode"
                            placeholder="ZIP Code"
                            defaultValue={memberInfo.postalCode || ""}
                          />
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">Country</label>
                          <select
                            className="form-control btn-square"
                            name="country"
                            defaultValue={memberInfo.country || ""}
                          >
                            <option value="0">--Select Country--</option>
                            {CountryList.map((data) => {
                              return (
                                <option value={data.name}>{data.name}</option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group" style={{ marginBottom: "16px" }}>
                          <label className="form-label">About Me</label>
                          <textarea
                            className="form-control"
                            rows="5"
                            name="aboutMe"
                            placeholder="Enter About your description"
                            defaultValue={memberInfo.aboutMe || ""}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer float-right"
                    style={{borderTop: "1px solid #f6f7fb", background: "#fff", padding: "30px" }}
                  >
                    <button className="btn btn-primary float-end" type="submit">
                      Update Profile
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MemberEdit;
